import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';

export default function AdminRoute({ children }) {
    const { isAuthenticated, isAdmin, loading } = useAuth();
    const loc = useLocation();
    if (loading) return null;
    if (!isAuthenticated) return <Navigate to="/login" state={{ from: loc }} replace />;
    if (!isAdmin) return <Navigate to="/home" replace />;

    console.log('auth debug', {
        isAuthenticated,
        isAdmin,
        // groups: user?.signInUserSession?.idToken?.payload?.['cognito:groups'],
        testGroups: process.env.REACT_APP_TEST_USER_GROUPS
    });
    return children;
}